import { HttpClient } from '@/common/helpers';
import { BackendService } from '@/types/BackendService';

function ProfileService() {
	return {
		profile: () => {
			return HttpClient(BackendService.Auth).get('/profile');
		},
		getAllUserProfile: () => {
			return HttpClient(BackendService.Auth).get('/user-profile');
		},
		updateUserProfile: (email: string, data: { fullName?: string; phoneNumber?: string }) => {
            return HttpClient(BackendService.Auth).put(`/user-profile/${email}`, data);
        },
		adminUpdateUserProfile: (email: string, data: {
			fullName?: string;
			phoneNumber?: string;
			company?: string;
			role?: string;
			disabled?: boolean;
			location?: {
				country: string;
				state: string;
				city: string;
				postalCode: string;
			};
		}) => {
            return HttpClient(BackendService.Auth).put(`/user-profile/admin/${email}`, data);
        },
		register: (values: {
			email: string;
			companyUid: string;
			fullName: string;
			role: string;
			phoneNumber?: string;
			location?: {
				country: string;
				state: string;
				city: string;
				postalCode: string;
			}
		}) => {
			return HttpClient(BackendService.Auth).post('/register', values);
		},
		softDeleteUser: (data: { uid: string; companyUid: string }) => {
			return HttpClient(BackendService.Auth).post('/user-profile/softdelete', data);
		},
	};
}
export default ProfileService();
